import { PlayerService } from "./PlayerService";

export type InventoryState = { inventory: string[] };
export class InventoryService {
    private readonly _playerService: PlayerService = new PlayerService();

    public async getInventory(): Promise<InventoryState> {
        const data: InventoryState = await fetch(`${VITE_API_URL}inventory/get-inv`, {
            headers: {
                "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
            },
        }).then(res => res.json() as Promise<InventoryState>);
        return data;
    }
}
